// extracted by mini-css-extract-plugin
export default {"Chevron":"foapW","Content":"Kbb01","Details":"PTcWj","Summary":"H0Zjx"};